import { GUIDE_SEARCH_PARAM } from './managerOperatingSystem.constants';

/**
 * Keeps the selected guide when that id is still on the roster. Otherwise
 * selects the first remaining guide, or clears the selection when none remain.
 * @param guideIds - Supervised guide ids in roster order.
 * @param guideParam - Current `guide` search param.
 * @returns The guide id to keep on the URL, or null when the roster is empty.
 */
export function resolveSelectedManagerOperatingSystemGuide(
  guideIds: readonly string[],
  guideParam: string | null
): string | null {
  if (guideIds.length === 0) {
    return null;
  }
  if (guideParam != null && guideIds.includes(guideParam)) {
    return guideParam;
  }
  return guideIds[0];
}

/**
 * Writes or clears the guide query param without dropping MOS filters.
 * @param searchParams - Existing query string.
 * @param guideId - Selected guide, or null to remove the param.
 * @returns Updated search params.
 */
export function setManagerOperatingSystemGuideSearchParam(
  searchParams: URLSearchParams,
  guideId: string | null
): URLSearchParams {
  const next = new URLSearchParams(searchParams);
  if (guideId == null) {
    next.delete(GUIDE_SEARCH_PARAM);
  } else {
    next.set(GUIDE_SEARCH_PARAM, guideId);
  }
  return next;
}
